import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './index.css'
import router from './router'
import { useAuthStore } from './stores/authStore'

// Import rrweb replay component
import { RrwebReplay } from './rrweb-replay.js'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

app.config.globalProperties.$rrwebReplay = RrwebReplay

// Initialize auth before first navigation
const authStore = useAuthStore()
authStore.initialize().finally(() => {
  app.mount('#app')
})
